import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export type ListStatusFragment = (
  { __typename: 'List' }
  & Pick<Types.List, 'id' | 'status'>
);

export const ListStatusFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ListStatus' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'List' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

interface UseListStatusFragmentOptions
  extends Omit<
    Apollo.UseFragmentOptions<ListStatusFragment, Apollo.OperationVariables>,
    'fragment' | 'fragmentName' | 'from'
  > {
  from: Apollo.StoreObject | Apollo.Reference;
  returnPartialData?: boolean;
}

interface UseListStatusFragmentResult
  extends Omit<Apollo.UseFragmentResult<ListStatusFragment>, 'data'> {
  data?: ListStatusFragment;
}

export const useListStatusFragment = ({
  from,
  returnPartialData,
  ...options
}: UseListStatusFragmentOptions): UseListStatusFragmentResult => {
  const result = Apollo.useFragment<ListStatusFragment>({
    ...options,
    fragment: ListStatusFragmentDoc,
    fragmentName: 'ListStatus',
    from: {
      __typename: 'List',
      ...from,
    },
  });

  // Ensure that the fragment result is not typed as a DeepPartial.
  if (!result.complete && !returnPartialData) {
    return {
      ...result,
      data: undefined,
    };
  }

  return { ...result, data: result.data as ListStatusFragment };
};
